.unassigned-action-item {
  min-width: 150px;
}

.is-locked {
  display: flex;
  justify-content: space-between;
}

.lock-icon {
  width: 12px;
  height: 12px;
}
